// extracted by mini-css-extract-plugin
export default {"InputFile":"InputFile_InputFile__6Qwuh","DragOver":"InputFile_DragOver__JM+jw","Holder":"InputFile_Holder__3GTpy","Label":"InputFile_Label__kfPUo","Input":"InputFile_Input__sWigN"};